
function UpgradedMembershipComponent() {
    return (
      <div className="UpgradedMembershipComponent">
        <h1>Missing</h1>
        <div>UpgradedMembershipComponent</div>
      </div>
    )
  }   
  
  
    export default UpgradedMembershipComponent;  